<template>
  <div class="employees">
    <RouterView />
    <div class="box wrapper-employees">
      <div class="title-container is-flex">
        <h2 class="title is-3 has-text-primary title-employees">
          Mis empleados
        </h2>
        <div class="buttons">
          <div class="field is-grouped">
            <p class="control">
              <RouterLink
                class="button is-primary btn-add-employee"
                :to="{ name: 'EmployeePush' }"
              >
                <BIcon
                  icon="plus"
                />
                <span>
                  Nuevo empleado
                </span>
              </RouterLink>
            </p>
            <p class="control">
              <RouterLink
                class="button is-illuminating-emerald btn-bulk-upload-employees"
                :to="{ name: 'EmployeeBulkUpload' }"
              >
                <BIcon
                  icon="cloud-upload-outline"
                />
                <span>
                  Carga masiva
                </span>
              </RouterLink>
            </p>
          </div>
        </div>
      </div>

      <div class="table-container">
        <BTable
          :data="$store.state.employees.list"
          :loading="$store.state.employees.loading"
          :total="$store.state.employees.count"
          :current-page="page"
          :columns="columns"
          :per-page="size"
          backend-pagination
          paginated
          @page-change="changePage"
        >
          <template slot-scope="props">
            <BTableColumn
              field="name"
              label="Nombre"
              internal
            >
              {{ props.row.name }}
            </BTableColumn>
            <BTableColumn
              field="email"
              label="Email"
              internal
            >
              {{ props.row.email }}
            </BTableColumn>
            <BTableColumn
              field="curp"
              label="CURP"
              internal
            >
              {{ props.row.rfc.curp }}
            </BTableColumn>
            <BTableColumn
              field="rfc"
              label="RFC"
              internal
            >
              {{ props.row.rfc.rfc }}
            </BTableColumn>
            <BTableColumn
              field="updatedAt"
              label="Fecha última actualización"
              internal
            >
              {{ props.row.updatedAt | toHumanDateTime }}
            </BTableColumn>

            <BTableColumn
              field="controls"
              label=""
              internal
            >
              <AppRadialMenu
                :size="36"
                :item-size="48"
                :radius="80"
                :angle-restriction="50"
                :rotate="-25"
              >
                <AppRadialMenuItem
                  class="tooltip is-tooltip-info has-background-info has-text-white is-tooltip-left"
                  data-tooltip="Eliminar"
                >
                  <RouterLink
                    class="action-option"
                    :to="{ name: 'EmployeeDelete', params: { employee: props.row.id } }"
                  >
                    <BIcon
                      icon="delete"
                      class="action-option-icon"
                    />
                  </RouterLink>
                </AppRadialMenuItem>

                <AppRadialMenuItem
                  class="tooltip is-tooltip-link has-background-link has-text-white is-tooltip-left"
                  data-tooltip="Editar"
                >
                  <RouterLink
                    class="action-option"
                    :to="{ name: 'EmployeeEdit', params: { employee: props.row.id } }"
                  >
                    <BIcon
                      icon="pencil"
                      class="action-option-icon"
                    />
                  </RouterLink>
                </AppRadialMenuItem>
              </AppRadialMenu>
            </BTableColumn>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <BIcon
                    icon="emoticon-sad"
                    size="is-large"
                  />
                </p>
                <p>No tienes ningún empleado</p>
              </div>
            </section>
          </template>
        </BTable>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Employees',

  components: {
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '@/components/AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '@/components/AppRadialMenuItem.vue'),
  },

  data() {
    return {
      columns: [
        { field: 'name', label: 'Nombre' },
        { field: 'email', label: 'Email' },
        { field: 'curp', label: 'CURP' },
        { field: 'rfc', label: 'RFC' },
        { field: 'updatedAt', label: 'Fecha última actualización' },
        { field: 'controls', label: '' },
      ],
    };
  },

  computed: {
    page() {
      return parseInt(this.$route.query.page, 10);
    },
    size() {
      return parseInt(this.$route.query.size, 10);
    },
  },

  beforeRouteEnter({ name, query }, from, next) {
    if (name === 'Employees') {
      if (query.page && query.size) {
        next();
      } else {
        const { page = 1, size = 20 } = query;
        next({ name, query: { page, size } });
      }
    } else {
      next();
    }
  },

  async beforeRouteUpdate({ name, query }, from, next) {
    this.$store.commit('employees/setValue', { accessor: 'email', value: '' });
    if (name === 'Employees') {
      if (query.page && query.size) {
        const { page = 1, size = 20 } = query;
        await this.$store.dispatch('employees/getAll', { page, size });
        next();
      } else {
        const { page = 1, size = 20 } = query;
        await this.$store.dispatch('employees/getAll', { page, size });
        next({ name, query: { page, size } });
      }
    } else {
      next();
    }
  },

  async beforeMount() {
    const { page = 1, size = 20 } = this.$route.query;
    this.$store.commit('employees/setValue', { accessor: 'email', value: '' });
    await this.$store.dispatch('employees/getAll', { page, size });
  },

  methods: {
    changePage(event) {
      this.$router.push({
        name: 'Employees',
        query: { page: event, size: 20 },
      });
    },
  },
};
</script>

<style scoped>
.employees {
  padding: 1rem;
  padding-bottom: 6rem;
}

.title-container.is-flex {
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  flex-wrap: wrap;
}

.title {
  margin-bottom: 0;
}

@media screen and (max-width: 768px) {
  .title {
    margin-bottom: 1rem;
  }
}
</style>

<style lang="scss">
.employees .pagination {
  margin-right: 4px;
}
</style>
